import Avatar, { AvatarProps } from '@alltrails/shared/denali/components/Avatar';
import AvatarStack from '@alltrails/shared/denali/components/AvatarStack';
import type { User } from 'types/User';
import { fullName } from '@alltrails/shared/utils/formatters/textFormatters';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { LanguageSupportUtil } from '../../../utils/language_support_util';

type UserImageLinkProps = {
  taggedAvatars?: Omit<AvatarProps, 'testId'>[];
  user: User & { firstName?: string; lastName?: string };
  className?: string;
};

const UserImageLink = ({ user, className, taggedAvatars }: UserImageLinkProps) => {
  const languageRegionCode = useLanguageRegionCode();

  if (!user) {
    return null;
  }

  if (taggedAvatars?.length > 1) {
    return <AvatarStack size="sm" avatars={taggedAvatars} totalAvatars={taggedAvatars.length} testId="tagged-avatars" maxAvatars={3} />;
  }

  return (
    <Avatar
      className={className}
      userName={fullName(user)}
      userId={user?.id}
      testId={`user-link-${user?.firstName}-image`}
      linkInfo={{ href: LanguageSupportUtil.wrapUrlSafe(ServerCommunicationUtil.usersPath(user), languageRegionCode) }}
    />
  );
};

export default UserImageLink;
